import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import { viewActivity } from '../actions/viewActivity';
import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';
var viewActivityUrl = 'https://go.microsoft.com/fwlink/?linkid=872494';
export default orchestrator(viewActivity, function viewActivity() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            logUsage(datapoints.PremiumDashViewRecentActivity.datapoint.name);
            window.open(viewActivityUrl, '_blank');
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=viewActivity.js.map